// extracted by css-extract-rspack-plugin
export default {"codeSpanWithMargin":"mg2CCcgpIJsjhaqY"};